export default "__VITE_ASSET__BNPt2FQ7__"